import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_flats-clean-service/artifacts/2b1a8yim_Screenshot_20260123_012606_Drive.jpg";

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="w-full py-4 px-6 bg-white border-b border-gray-100">
        <div className="max-w-4xl mx-auto">
          <a href="/">
            <img 
              src={LOGO_URL} 
              alt="Just Cleaned" 
              className="h-12 w-auto object-contain"
            />
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="px-6 py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-semibold text-gray-900 mb-8">Terms & Conditions</h1>
          
          <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">Last updated: January 2025</p>
            
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Services</h2>
              <p>Just Cleaned provides communal block cleaning services for managed residential properties. All services are provided following a site assessment and written agreement.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Quotations</h2>
              <p>Quotes provided are indicative until confirmed in writing following a site assessment. Final pricing may vary based on the scope of work, access requirements, and cleaning frequency agreed.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Cleaning Schedules</h2>
              <p>All cleaning schedules are agreed in writing prior to commencement of services. Any changes to schedules must be communicated and confirmed by both parties.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Access Requirements</h2>
              <p>The client is responsible for providing access to all communal areas to be cleaned. If access is not provided as agreed, we reserve the right to reschedule or charge for the missed visit.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Insurance</h2>
              <p>Just Cleaned maintains Public Liability, Employer's Liability, and Professional Indemnity insurance. Certificates are available upon request.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">No Obligation</h2>
              <p>Submitting an enquiry through this website does not create a contractual obligation. A formal agreement is required before services commence.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Governing Law</h2>
              <p>These terms are governed by the laws of England and Wales.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">Contact Us</h2>
              <p>For any questions about these terms, please contact us at:</p>
              <p className="mt-2"><strong>Email:</strong> justcleanedltd@gmail.com</p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="px-6 py-8 bg-white border-t border-gray-100 mt-12">
        <div className="max-w-4xl mx-auto text-center text-gray-500 text-sm">
          <p>Just Cleaned • Communal block cleaning</p>
        </div>
      </footer>
    </div>
  );
};

export default TermsConditions;
